require('./detailsList.style.scss');

class DetailsListController {
    constructor(utilsService, iamPersistenceService, $window) {
        this.iamPersistenceService = iamPersistenceService;
        this.$window = $window;
        this.details = this.details;
        this.utilsService = utilsService;
        this.expandedItems = {};
    }

    $onChanges(changes) {
        if (changes && changes.detailsChanged) {
            this.expandedItems = {};
        }
    }

    addOne() {
        this.counter = (this.counter || 0) + 1;
    }

    hasDetailsPermissions() {
        if (this.permissions) {
            return this.iamPersistenceService.hasPermissions(this.permissions);
        } else {
            return true;
        }
    }

    toggleSubItems(item, event) {
        event.stopPropagation();

        this.expandedItems[item.uuid] = !this.expandedItems[item.uuid];
        if (this.expandedItems[item.uuid]) {
            let i = this.details.indexOf(item) + 1;
            item.subItems = item.subItems.map((tempItem, i) => {
                return Object.assign(tempItem, { subItem: true, uuid: i });
            });
            this.details.splice(i, 0, ...item.subItems); //add subItems array to details list
        } else {
            let uuids = [];
            item.subItems.forEach((item) => uuids.push(item.uuid));
            this.details = this.details.filter((item) => uuids.indexOf(item.uuid) === -1);
        }
    }

    openLink(link) {
        this.$window.open(`${link}`, '_blank');
    }
}
DetailsListController.$inject = ['utilsService', 'iamPersistenceService', '$window'];

const detailsListComponent = {
    controller: DetailsListController,
    controllerAs: 'detailsListCtrl',
    template: require('./detailsList.template.html'),
    bindings: {
        details: '=?',
        iconTooltip: '@',
        headerText: '@',
        customHeight: '<?',
        permissions: '<?',
        detailsChanged: '<?',
    },
};

module.exports = detailsListComponent;



// WEBPACK FOOTER //
// ./src/shared/detailsList/detailsList.component.js